<template>
    <div
        class="l-ss-c-catalog-content">
        <div class="l-ss-c-catalog-root-categories">
            <category-item
                v-for="category in categories"
                :key="category.id"
                :category="category"
                :active="currentCategory.id === category.id"
                @click="$emit('change', $event)"
                @mouseenter="$emit('input', category)"/>
        </div>
        <div
            class="l-ss-c-catalog-content-inner"
            v-if="currentCategory.id">
            <a
                :href="makeCategoryUrl(currentCategory.id)"
                class="l-ss-c-catalog-category-title"
                @click="$emit('change', { event: $event, category: currentCategory })"
                v-html="currentCategory.title">
            </a>

            <div class="l-ss-c-catalog-categories-list-wrapper">
                <catalog-desktop-second-categories-list
                    v-for="secondLevelCategory in currentCategory.child"
                    :key="secondLevelCategory.id"
                    :category="secondLevelCategory"
                    @change="$emit('change', $event)"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { computed, inject } from '@vue/composition-api';

    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';

    import CategoryItem from '@/core/components/catalog/category-item.vue';
    import CatalogDesktopSecondCategoriesList
        from '@/core/components/catalog/catalog-desktop-second-categories-list.vue';

    export default {
        components: { CatalogDesktopSecondCategoriesList, CategoryItem },
        model: {
            prop: 'selectedCategory',
            event: 'input',
        },
        props: {
            categories: {
                type: Array,
                required: true,
            },
            selectedCategory: {
                type: Object,
            },
        },
        setup(props) {
            const makeCategoryUrl = inject('makeCategoryUrl');

            const currentCategory = computed(() => {
                const { selectedCategory } = props;

                if (!selectedCategory.parent) {
                    return selectedCategory;
                }

                return selectedCategory.parent;
            });

            return {
                iconArrowRight,
                makeCategoryUrl,
                currentCategory,
            };
        },
    };
</script>
